import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";
import {useContentful} from "react-contentful";

const getQuery = (query) => {
    return gql`
        query getHtmlComponentElements($id: String!, $locale: String!){
            htmlComponentsCollection(where: {sys: {id: $id}}, limit: 1, locale: $locale) {
                items {
                    title
                    subtitle
                    extraParameters
                    gridColumns
                    image {
                        url
                    }
                    ${query}
                }
            }
        }
    `;
};

export const useHtmlComponentGql = (id, componentQuery) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(getQuery(componentQuery ? componentQuery : ""), {variables: {id, locale: localeUppercase}, errorPolicy: "all"});

    if (error?.message) {
        logger(error?.message, "error", "useHtmlComponentGql", error?.stack);
    }

    return {
        componentData: data?.htmlComponentsCollection?.items[0],
        componentDataLoading: loading,
        componentDataError: error
    };
};

export const useHtmlComponentRest = (id) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();

    const { data, error, loading } = useContentful({
        contentType: "htmlComponents",
        id,
        locale: localeUppercase
    });

    if (error?.message) {
        logger(error?.message, "error", "useHtmlComponentRest", error?.stack);
    }

    return {
        componentData: data,
        componentDataLoading: loading,
        componentDataError: error
    };
};
